import { render } from "./IssueDetailPanel.vue?vue&type=template&id=149b40c0&scoped=true"
import script from "./IssueDetailPanel.vue?vue&type=script&lang=js"
export * from "./IssueDetailPanel.vue?vue&type=script&lang=js"

import "./IssueDetailPanel.vue?vue&type=style&index=0&id=149b40c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149b40c0"]])

export default __exports__